import { EMBED_INTERNAL_PARAM } from '@anm/constants/wave-editor';
import { PageProps } from '@anm/contexts/VideoTemplatesPageContext';
import pagesData, { SliderContent, StockContent } from '@anm/data/video-templates/pages';
import * as semrush from '@anm/helpers/semrush'
import usePageParams from '@anm/hooks/usePageParams';
import { safeParse } from '@anm/helpers/safeOperation';
import { memo, FC } from 'react';

import StockList from '../../stocks/StockList';
import CalendarEventsList from '../CalendarEventsList';
import TemplateListWithPagination from '../TemplateListWithPagination';
import TemplatesSliderWrapper from '../TemplatesSliderWrapper';

const PageContent: FC<PageProps> = ({ pageName }) => {
  const { content } = pagesData[pageName];

  const { embed, isSemrush } = usePageParams();
  const isSemrushParsed = safeParse(isSemrush || 'false') || semrush.isSemrushIframe();
  const isInternalEmbed = embed === EMBED_INTERNAL_PARAM;

  return (
    <>
      {content.map(({ type, ...restProps }) => {
        const { title, search } = restProps as SliderContent;

        switch (true) {
          case type === 'slider': {
            return <TemplatesSliderWrapper key={title} {...(restProps as SliderContent)} />;
          }
          case type === 'templates': {
            const templateKey = title || 'templates';
            return <TemplateListWithPagination key={templateKey} {...restProps} />;
          }
          case type === 'stocks' && !isSemrushParsed: {
            const stockKey = title + search.name || 'stocks';
            return <StockList key={stockKey} {...(restProps as StockContent)} />;
          }
          case type === 'calendar' && !isInternalEmbed:
            return <CalendarEventsList key="calendar" />;
          default:
            return null;
        }
      })}
    </>
  );
};

export default memo(PageContent);
